<template>
    <div class="customerlist">
        <div class="customerlistContain">
            <div class="customlistSideRouter">
              <customer-list-side
                      @editFilter="editFilter"
                      ref="customerListSide"
              />
            </div>
            <div class="customerListRouter">
                <keep-alive>
                    <router-view
                            name="customerListRouter"
                            ref="customerListRouter"
                            @editCustomer="editCustomer"
                    />
                </keep-alive>

            </div>
        </div>
    </div>
</template>

<script>

    import CustomerListSide from "./customerlistside/CustomerListSide";
    export default {
        name: "CustomerList",
        components: {CustomerListSide },
        data(){
            return{
                isActive:1,
                company:0,
                fileList:[],
                clientTotal:0,
                pageSize:1000,
                currentPage:1,
                clientCompanyTotal:0,
                clientFilterList:[],
                companyFilterList:[],
                clientSeach:[],
                filterId:'',
                searchNum:0,
                companySearchNum:0


            }
        },
        methods:{
            editFilter(){
                this.$nextTick(()=>{
                    this.$refs.customerListRouter.getClientList()
                    console.log(this.$refs.customerListRouter.customerCluePage)
                    this.$refs.customerListRouter.customerCluePage = 1
                })
            },
            editCustomer(){
                this.$nextTick(()=>{
                    this.$refs.customerListSide.$refs.sideRouter.getClientFilter()
                    this.$refs.customerListSide.$refs.sideRouter.getCustomerClue()
                })
            }
        }
    }
</script>

<style lang="less">
@import "../../assets/less/customlist/customlist";
.el-table {
  .el-table__fixed {
    height:auto !important; // 此处的important表示优先于element.style
    bottom:17px; // 改为自动高度后，设置与父容器的底部距离，则高度会动态改变
  }
  .el-table__fixed-right{
    height:auto !important; // 此处的important表示优先于element.style
    bottom:17px; // 改为自动高度后，设置与父容器的底部距离，则高度会动态改变
  }
}
</style>